import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmployeeTracking } from '@/components/employee/tracking';

const locationSearchSchema = z.object({
  date: z.string().optional(), // YYYY-MM-DD
  /** Where the user came from, when they arrived by a link rather than the
   *  sidebar. Drives the back button; absent means there is nowhere to go
   *  back to. */
  from: z.string().optional(),
  /** Human-readable name of that origin, e.g. "Employee Dashboard". Kept in
   *  the URL rather than mapped from the path, so a new origin needs no
   *  lookup table maintained here. */
  fromLabel: z.string().optional(),
});

export const Route = createFileRoute('/(app)/employee/location/')({
  component: EmployeeLocationRoute,
  validateSearch: locationSearchSchema,
});

function EmployeeLocationRoute() {
  // Own view (the date picker navigates here): same attendance-day window as
  // /employee/tracking, so a date change cannot silently drop the bracket.
  return (
    <EmployeeTracking
      showBackButton={false}
      applyAttendanceWindow
    />
  );
}
